import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

const LoadingContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: ${props =>
    props.color === 'white'
      ? `rgba(32,32,32,${props.opacity})`
      : `rgba(247,247,247,${props.opacity})`};
`;

const moveAnimation = keyframes`
  from {
    opacity:0.1;
  }

  to {
    opacity:0.5;
  }
`;

const Loadersvg = styled.div`
  animation: ${moveAnimation} 1s ease-in-out infinite;
  position: relative;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  left: 50%;
  top: 50%;
  margin-left: -50px;
  margin-top: -50px;
  width: 100px;
  height: 100px;
`;

const AppLoader = props => (
  <LoadingContainer color={props.color} opacity={props.opacity}>
    <Loadersvg>
      <svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.5 60V40.2071L49.5 21.2071L49.5 40V59.7929L30.5 78.7929V60Z"
          stroke="#4E56FF"
        />
        <circle cx="60" cy="70" r="9.5" stroke={props.color} />
      </svg>
    </Loadersvg>
  </LoadingContainer>
);

AppLoader.propTypes = {
  color: PropTypes.string,
  opacity: PropTypes.number,
};

AppLoader.defaultProps = {
  color: 'white',
  opacity: 1,
};
export default AppLoader;
